import { ADD_OVERVIEW_COMMENT } from '../action_types';

export default (comment) => ({
  type: ADD_OVERVIEW_COMMENT,
  comment,
});
